import { createElement, memo } from "react";
import { useTranslation } from "react-i18next";
import ReactDOMServer from "react-dom/server";

type TextProps = {
  lKey: string | JSX.Element;
  domElement?: string;
  className?: string;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
};

export const Text = memo((props: TextProps) => {
  const { t } = useTranslation();
  const { lKey, domElement = "span", className, onClick } = props;

  const lKeyString = typeof lKey === "string" ? lKey : ReactDOMServer.renderToString(lKey);

  return createElement(domElement, {
    className,
    onClick,
    dangerouslySetInnerHTML: { __html: t(lKeyString) },
  });
});
